<template>
    <vue-modal-custom
        v-model="modal.visible"
        :header="false"
        :footer="false"
        :backdrop="false"
        :closable="false"
        :keyboard="false"
        :modalBodyClass="$prefixClass.modal + `-affiliate`"
    >
        <img class="m-b-12" src="../assets/images/affiliate-bg.svg"/>
        <p class="m-b-16" v-html="$t('app.components.affiliate_title')"></p>
        <div class="affiliate__actions">
            <a-button class="m-r-8" type="primary" ghost @click="openLink">{{$t('app.buttons.save_it')}}</a-button>
            <a-button type="primary" @click="discoverHere">{{$t('app.buttons.discover_here')}}</a-button>
        </div>
    </vue-modal-custom>
</template>
<script>
import { mapGetters } from 'vuex'
import { types as typesAuth } from '@/modules/auth/constant'
import cookie from 'js-cookie'
export default {
    name: 'ModalAffiliate',
    props: {
        value: {
            type: Object,
            require: true
        }
    },
    data() {
        return {
            href: 'https://go.onecommerce.io/Shopify-FireApps024',
            hrefDiscover: 'https://go.onecommerce.io/Shopify-FireApps032'
        }
    },
    computed: {
        ...mapGetters({
            store : typesAuth.getters.GET_STORE,
        }),
        modal: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        },
        cookieName() {
            return `hide_modal_affiliate_${this.store.id}`
        }
    },
    methods: {
        openLink() {
            this.hidePopup()
            window.open(this.href, '_blank')
        },
        discoverHere() {
            this.hidePopup()
            window.open(this.hrefDiscover, '_blank')
        },
        hidePopup() {
            this.modal.visible = false
            cookie.set(this.cookieName, true , { 
                expires: 60
            });
        }
    }
}
</script>
<style lang="scss">
    .#{$modal}-affiliate {
        width: 500px !important;
        .#{$modal} {
            &-body {
                text-align: center;
                padding: 20px 30px 24px 30px;
                .#{$btn}-primary {
                    height: 40px;
                }
            }
        }
    }
</style>
